import LoadingSpinner from "@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner";
import { useCleanBeauty } from "../../hooks/useCleanBeauty/useCleanBeauty";
import { FreeFrom } from "./components/FreeFrom/FreeFrom";
import styles from "./GoodToKnow.module.scss";
import { Badges } from "./components/Badges/Badges";
import { CleanBeautyLabels } from "../../hooks/useCleanBeauty/cleanBeautySchema";

type GoodToKnowProps = {
  freeFrom: string[];
  badges: CleanBeautyLabels[];
};

const GoodToKnow = ({ freeFrom: freefrom, badges }: GoodToKnowProps) => {
  return (
    <section data-testid="good-to-know" className={styles.goodToKnowWrapper}>
      <h2 className={styles.title}>Good to Know</h2>
      <p className={styles.text}>
        Useful information on how this product is good for the environment and
        for you.
      </p>
      <div className={styles.goodToKnow}>
        {badges.length > 0 && (
          <div className={styles.badges}>
            <Badges labels={badges}></Badges>
          </div>
        )}
        {freefrom.length > 0 && (
          <div className={styles.freeform}>
            <FreeFrom freeFrom={freefrom} />
          </div>
        )}
      </div>
      <span className={styles.poweredBy}>
        <span className={styles.disclaimer}>Disclaimer:</span>
        The free from list and conscious beauty labels are provided by Skin
        Match Technology for information purposes only. Formulation and
        ingredients are subject to change by the brand. Please refer to the
        product packaging for the most up-to-date ingredients list and be aware
        that it may change or vary from time to time. For any concerns please
        seek professional advice before use.
      </span>
    </section>
  );
};

type Props = {
  ean: string;
  cleanBeautyBaseUrl: string;
};

export const GoodToKnowUI = ({ ean, cleanBeautyBaseUrl }: Props) => {
  const cleanBeauty = useCleanBeauty(ean, cleanBeautyBaseUrl);
  switch (cleanBeauty.status) {
    case "No Action":
    case "Error":
      return null;
    case "Loading":
      return (
        <LoadingSpinner data-testid="good-to-know-loading-spinner" centered />
      );
    case "Done": {
      const { free_From: cleanBeautyFreefrom, labels: badges } =
        cleanBeauty.data || { free_From: [], labels: [] };
      if (cleanBeautyFreefrom.length === 0 && badges.length === 0) {
        return null;
      }
      return (
        <GoodToKnow freeFrom={cleanBeautyFreefrom} badges={badges}></GoodToKnow>
      );
    }
    default: {
      return null;
    }
  }
};
